import { BaseModel } from './base';

export enum UploadDataType {
  photo = 0,
  document = 1,
}

export const UploadDataTypeLabels: Record<UploadDataType, string> = {
  [UploadDataType.photo]: 'general.photo',
  [UploadDataType.document]: 'api.models.upload.document',
};

export enum UploadType {
  customer = 0,
  reservation = 1,
  reservationCustomer = 2,
  location = 3,
}

export const UploadTypeLabels: Record<UploadType, string> = {
  [UploadType.customer]: 'general.customer',
  [UploadType.reservation]: 'general.reservation',
  [UploadType.reservationCustomer]: 'api.models.reservationCustomer',
  [UploadType.location]: 'general.location',
};

export class Upload extends BaseModel {
  idPhoto!: number;
  dataType!: UploadDataType;
  type!: UploadType;
  url!: string;

  override objectID(): string | null {
    return this.idPhoto?.toString() ?? null;
  }

  get isDataTypePhoto(): boolean {
    return this.dataType === UploadDataType.photo;
  }

  get isDataTypeDocument(): boolean {
    return this.dataType === UploadDataType.document;
  }

  get isTypeCustomer(): boolean {
    return this.type === UploadType.customer;
  }

  get isTypeReservation(): boolean {
    return this.type === UploadType.reservation;
  }

  get isTypeReservationCustomer(): boolean {
    return this.type === UploadType.reservationCustomer;
  }

  get isTypeLocation(): boolean {
    return this.type === UploadType.location;
  }
}
